<template>
    <div class="page-main">
        <div class="search-bar">
            <div class="left-bar">
                <!--<Button :type="filters.timeSolt===1?'primary':'default'" v-on:click="changeTimeSolt(1)">近一周</Button>-->
                <!--<Button :type="filters.timeSolt===2?'primary':'default'" v-on:click="changeTimeSolt(2)">近一月</Button>-->
                <!--<Button :type="filters.timeSolt===3?'primary':'default'" v-on:click="changeTimeSolt(3)">近一年</Button>-->
                <template v-if="tabTag===1">
                    <button v-on:click="changeTabTag(2)" class="left-bar-tab-btn">
                        <span>云端报告</span>
                    </button>
                    <button v-on:click="changeTabTag(1)" class="left-bar-tab-btn active">
                        <span>课堂评价</span>
                    </button>
                </template>
                <template v-else>
                    <button v-on:click="changeTabTag(2)" class="left-bar-tab-btn active"><span>云端报告</span></button>
                    <button v-on:click="changeTabTag(1)" class="left-bar-tab-btn">
                        <span>课堂评价</span>
                    </button>
                </template>
            </div>
            <div class="right-bar">
                <div class="right-mian">
                    <input placeholder="请输入教师、学生姓名" class="input-cla" v-model="filters.keyWord"
                           v-on:keyup.enter="handleSearch" v-if="tabTag===1"/>
                    <input placeholder="请输入报告名称、教师姓名" class="input-cla" v-model="filters.keyWord"
                           v-on:keyup.enter="handleSearch" v-else/>
                    <div class="search-btn" v-on:click="handleSearch">
                        <div class="search-icon">
                            <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                 height="100%"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-main-wrap">
            <div class="table-main">
                <!--课堂互动-->
                <div class="table-content" v-if="tabTag===1">
                    <div class="header">
                        <Col :span="2">
                        <span>序号</span>
                        </Col>
                        <Col :span="4">
                        <span>学校名称</span>
                        </Col>
                        <Col :span="4">
                        <span>班级名称</span>
                        </Col>
                        <Col :span="3">
                        <span>教师姓名</span>
                        </Col>
                        <Col :span="3">
                        <span>学生姓名</span>
                        </Col>
                        <Col :span="4">
                        <span>互动内容</span>
                        </Col>
                        <Col :span="4">
                        <span>互动时间</span>
                        </Col>
                    </div>
                    <div class="row-wrap">
                        <template v-for="(item,index) in classInterList" v-if="classInterList.length>0">
                            <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                <Col :span="2">
                                <span>{{item.rowNum}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{$utils.isEmpty(item.schoolName) ===true ? '暂无':item.schoolName}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{$utils.isEmpty(item.className) ===true ? '暂无':item.className}}</span>
                                </Col>
                                <Col :span="3" class="col-content">
                                <span>{{$utils.isEmpty(item.teaName) ===true ? '暂无':item.teaName}}</span>
                                </Col>
                                <Col :span="3" class="col-content">
                                <span>{{$utils.isEmpty(item.stuName) ===true ? '暂无':item.stuName}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <template v-if="$utils.isEmpty(item.questionName)">
                                    <span>暂无</span>
                                </template>
                                <template v-else>
                                    <a :title="item.questionName" href="javascript:void(0);"
                                       v-on:click="lookInterInfo(item)"
                                       style="color: #2d8cf0;">{{item.questionName}}</a>
                                </template>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{$utils.isEmpty(item.createDate) ===true ? '暂无':item.createDate}}</span>
                                </Col>
                            </Row>
                        </template>
                        <template v-if="classInterList.length===0">
                            <Row :gutter="12" class="row-single">
                                <Col :span="24">
                                <span>暂无数据</span>
                                </Col>
                            </Row>
                        </template>
                    </div>
                </div>
                <!--云端互动-->
                <div class="table-content" v-else>
                    <div class="header">
                        <Col :span="2">
                        <span>序号</span>
                        </Col>
                        <Col :span="6">
                        <span>学校名称</span>
                        </Col>
                        <Col :span="6">
                        <span>报告名称</span>
                        </Col>
                        <Col :span="5">
                        <span>教师姓名</span>
                        </Col>
                        <Col :span="5">
                        <span>创建时间</span>
                        </Col>
                    </div>
                    <div class="row-wrap">
                        <template v-for="(item,index) in classInterList" v-if="classInterList.length>0">
                            <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                <Col :span="2">
                                <span>{{item.rowNum}}</span>
                                </Col>
                                <Col :span="6" class="col-content">
                                <span>{{item.schoolName ==='' ? '暂无':item.schoolName}}</span>
                                </Col>
                                <Col :span="6" class="col-content">
                                <template v-if="item.workName===''">
                                    <span>暂无</span>
                                </template>
                                <template v-else>
                                    <a :title="item.workName" href="javascript:void(0);"
                                       v-on:click="lookReport(item.workId,item.qtype)" style="color: #2d8cf0;">{{item.workName}}</a>
                                </template>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span>{{item.realname ==='' ? '暂无':item.realname}}</span>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span>{{item.createDate ==='' ? '暂无':item.createDate}}</span>
                                </Col>
                            </Row>
                        </template>
                        <template v-if="classInterList.length===0">
                            <Row :gutter="12" class="row-single">
                                <Col :span="24">
                                <span>暂无数据</span>
                                </Col>
                            </Row>
                        </template>
                    </div>
                </div>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1"></Page>
                </div>
            </div>
        </div>

        <div v-show="isShowModal">
            <div class="mask-box"></div>
            <div class="panel-box">
                <div class="close-btn">
                    <img class="logo-img" src="../../../../assets/images/databoard/close_btn.png" width="100%"
                         height="100%"
                         v-on:click="closeWin"/>
                </div>
                <div class="panel-main">
                    <div class="icon-box-wrap">
                        <img class="icon-box" :src="currentInter.evaluateTypeIcon" width="100%" height="100%">
                        <p class="icon-txt">{{currentInter.questionName}}</p>
                    </div>
                    <div class="info-box">
                        <p><span class="txt-item">{{currentInter.schoolName}}</span>
                            <span class="txt-item">{{currentInter.teaName}}老师</span> 对 <span class="txt-item">{{currentInter.stuName}}</span>
                            学生 </p>
                        <p>进行了 “ {{currentInter.questionName}} ” 的课堂互动</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {findInterEvaLList, findReportList} from "../../../../service/api.js";

    export default {
        name: "classInter-list",
        data () {
            return {
                tabTag: 2,//默认1:课堂互动  2:云端报告
                classInterList: [],
                reportList: [],//云端报告集合
                filters: {
                    schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                    timeSolt: 0,
                    keyWord: '',
                    startDate: '',
                    endDate: ''
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                isShowModal: false,
                currentInter: {}
            }
        },
        created () {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: "databoard",
                    name: "databoard",
                    params: {
                        schoolCode: this.$route.params.schoolCode,
                    }
                },
                {
                    title: this.$route.params.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部课堂互动",
                    path: "",
                    name: "classInterList"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 改变tab
             */
            changeTabTag (tag) {
                this.tabTag = tag;
                this.filters.keyWord = "";
                this.handleSearch();
                // if (tag === 1) {
                //     this.getClassInterList();
                // } else {
                //     this.getReportList();
                // }
            },
            /**
             * 获取资源列表
             */
            async getClassInterList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findInterEvaLList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.classInterList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 获取报告列表
             */
            async getReportList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findReportList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.classInterList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.pageParams.page = val;
                if (this.tabTag === 1) {
                    this.getClassInterList();
                } else {
                    this.getReportList();
                }
            },
            /**
             * 查询
             */
            handleSearch () {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                if (this.tabTag === 1) {
                    this.getClassInterList();
                } else {
                    this.getReportList();
                }
            },
            /**
             * 选择时间段
             */
            changeTimeSolt (type) {
                //反选的情况
                if (this.filters.timeSolt === type) {
                    this.filters.timeSolt = 0;
                    this.filters.startDate = '';
                    this.filters.endDate = '';
                } else {
                    this.filters.timeSolt = type;
                }
                //获取近一周时间
                if (this.filters.timeSolt === 1) {
                    this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 2) {
                    //获取近一月时间
                    this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 3) {
                    //获取近一年时间
                    this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';
                }
                this.handleSearch();
            },
            /**
             * 查看云端报告
             */
            lookReport (id, type) {
                let pathName = '';
                //题型类别 choice:选择 judge:判断 blankfilling:填空 subject:主观
                switch (type) {
                    case 'choice':
                        pathName = 'objectReport';
                        break;
                    case 'judge':
                        pathName = 'objectReport';
                        break;
                    case 'subject':
                        pathName = 'subjectReport';
                        break;
                    default:
                        pathName = 'fillReport';
                        break;
                }

                let routeData = this.$router.resolve({
                    name: pathName,
                    params: {
                        workId: id
                    }
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 查看互动详情
             */
            lookInterInfo (interObj) {
                this.isShowModal = true;
                this.currentInter = interObj;
            },
            /**
             * 关闭弹窗
             */
            closeWin () {
                this.isShowModal = false;
            }
        },
        mounted () {
            this.getReportList();
            // this.getClassInterList();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";

    .panel-box {
        background-image  : url("../../../../assets/images/databoard/modal-bg.png");
        background-repeat : no-repeat;
        background-size   : 100% 100%
    }
</style>
